import { GlobalStyles } from '@mui/material';
import React from 'react';

/**
 * Global Styles required for sparkasse webfonts
 *
 * @version [AIV]{version}[/AIV]
 * @author [SFP](https://gitlab.sfp.berlin/products/sparkasse.de/portals)
 * @see [https://styleguide.sparkasse.de/document/69#/ui-komponenten/typography]
 */
export const GlobalTypography = (): React.ReactElement => {
  return (
    <GlobalStyles
      styles={`
          {}
      
          @font-face {
            font-family: 'Sparkasse Regular';
            font-style: normal;
            font-display: swap;
            src: url('https://webfonts.sparkasse.de/Sparkasse_web_Rg.eot');
            src: url('https://webfonts.sparkasse.de/Sparkasse_web_Rg.woff2') format('woff2'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Rg.woff') format('woff'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Rg.ttf') format('truetype'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Rg.svg') format('svg');
          }

          @font-face {
            font-family: 'Sparkasse Medium';
            font-style: normal;
            font-display: swap;
            src: url('https://webfonts.sparkasse.de/Sparkasse_web_Md.eot');
            src: url('https://webfonts.sparkasse.de/Sparkasse_web_Md.woff2') format('woff2'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Md.woff') format('woff'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Md.ttf') format('truetype'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Md.svg') format('svg');
          }

          @font-face {
            font-family: 'Sparkasse Light';
            font-style: normal;
            font-display: swap;
            src: url('https://webfonts.sparkasse.de/Sparkasse_web_Lt.eot');
            src: url('https://webfonts.sparkasse.de/Sparkasse_web_Lt.woff2') format('woff2'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Lt.woff') format('woff'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Lt.ttf') format('truetype'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Lt.svg') format('svg');
          }

          @font-face {
            font-family: 'Sparkasse Serif';
            font-style: normal;
            font-display: swap;
            src: url('https://webfonts.sparkasse.de/SparkasseSerif_web_Rg.eot');
            src: url('https://webfonts.sparkasse.de/SparkasseSerif_web_Rg.woff2') format('woff2'),
              url('https://webfonts.sparkasse.de/SparkasseSerif_web_Rg.woff') format('woff'),
              url('https://webfonts.sparkasse.de/SparkasseSerif_web_Rg.ttf') format('truetype'),
              url('https://webfonts.sparkasse.de/SparkasseSerif_web_Rg.svg') format('svg');
          }

          @font-face {
              font-family: 'Sparkasse P1';
              font-weight: 400;
              font-style: normal;
              font-display: swap;
              src: url('https://webfonts.sparkasse.de/Sparkasse_web_Lt.eot');
              src: url('https://webfonts.sparkasse.de/Sparkasse_web_Lt.woff2') format('woff2'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Lt.woff') format('woff'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Lt.ttf') format('truetype'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Lt.svg') format('svg');
          }

          @font-face {
              font-family: 'Sparkasse P1';
              font-weight: 500 700;
              font-style: normal;
              font-display: swap;
              src: url('https://webfonts.sparkasse.de/Sparkasse_web_Md.eot');
              src: url('https://webfonts.sparkasse.de/Sparkasse_web_Md.woff2') format('woff2'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Md.woff') format('woff'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Md.ttf') format('truetype'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Md.svg') format('svg');
          }

          @font-face {
              font-family: 'Sparkasse B1';
              font-weight: 400;
              font-style: normal;
              font-display: swap;
              src: url('https://webfonts.sparkasse.de/Sparkasse_web_Rg.eot');
              src: url('https://webfonts.sparkasse.de/Sparkasse_web_Rg.woff2') format('woff2'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Rg.woff') format('woff'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Rg.ttf') format('truetype'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Rg.svg') format('svg');
          }

          @font-face {
              font-family: 'Sparkasse B1';
              font-weight: 500 700;
              font-style: normal;
              font-display: swap;
              src: url('https://webfonts.sparkasse.de/Sparkasse_web_Md.eot');
              src: url('https://webfonts.sparkasse.de/Sparkasse_web_Md.woff2') format('woff2'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Md.woff') format('woff'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Md.ttf') format('truetype'),
              url('https://webfonts.sparkasse.de/Sparkasse_web_Md.svg') format('svg');
          }

          @font-face {
            font-family: 'Sparkasse Head';
            font-weight: 700;
            font-style: normal;
            font-display: swap;
            src: url('https://webfonts.sparkasse.de/SparkasseHead_web_Rg.eot');
            src: url('https://webfonts.sparkasse.de/SparkasseHead_web_Rg.woff2') format('woff2'),
            url('https://webfonts.sparkasse.de/SparkasseHead_web_Rg.woff') format('woff'),
            url('https://webfonts.sparkasse.de/SparkasseHead_web_Rg.ttf') format('truetype'),
            url('https://webfonts.sparkasse.de/Sparkassehead_web_Rg.svg') format('svg');
        }`}
    />
  );
};
